import { apmBase } from "@elastic/apm-rum";

/**
 * Captures a critical bootstrap error in APM with context labels that identify it
 * as a bootstrap failure (not a normal runtime error).
 *
 * Called when the app cannot mount because a critical initialization step failed
 * (e.g. getPageContext network failure → "server not reachable" page is shown).
 */
export function captureBootstrapError(error: unknown, phase: "getPageContext" | "missingStoreOrUser"): void {
  if (import.meta.env.APP_APM_ENABLED !== "true") return;

  apmBase.captureError(error as Error);
  apmBase.addLabels({ bootstrapFailed: true, bootstrapPhase: phase });
  apmBase.setInitialPageLoadName(`BootstrapError/${phase}`);
}
